export default __webpack_public_path__ + "static/6-for-7667f578edf97fd5cb1cb1be59d93dc3.png";